/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * MIME type accepted by the sanitized public-image policy.
 */
export enum PublicSanitizedImageContentType {
    IMAGE_PNG = 'image/png',
    IMAGE_JPEG = 'image/jpeg',
    IMAGE_WEBP = 'image/webp',
    IMAGE_SVG_XML = 'image/svg+xml',
}
